// A file to manage the colors allowed in game (to make sure we don't misspell things)
// might be useful for localization for different languages
export const COLOR_BLUE = "Blue";
export const COLOR_GREEN = "Green";
export const COLOR_PURPLE = "Purple";
export const COLOR_YELLOW = "Yellow";